module.exports = __webpack_public_path__ + "img/resource_5.7187a20b.png";